import { render } from "./DefaultPostSectionAlbumCmp.vue?vue&type=template&id=6ccab095&scoped=true"
import script from "./DefaultPostSectionAlbumCmp.vue?vue&type=script&lang=js"
export * from "./DefaultPostSectionAlbumCmp.vue?vue&type=script&lang=js"

import "./DefaultPostSectionAlbumCmp.vue?vue&type=style&index=0&id=6ccab095&lang=css&scoped=true"

import exportComponent from "D:\\working\\MyCi4Vue\\myCi4Vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ccab095"]])

export default __exports__